export default "__VITE_ASSET__DGnND7A1__"